import KendoToolBarMixin from './KendoToolBarMixin'

export default {
    name: 'kendo-toolbar',
    mixins: [ KendoToolBarMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-vue-wrapper/src/KendoToolBar/index.js